import React, { useState } from 'react';
import AdSpaceTokenPlansAdminList from './components/TokenPlansAdminList';
import AdSpaceTokenPlansAdminAddTokenPlanPage from './components/TokenPlansAdminAddTokenPlanPage';
import { Box, Tabs, Tab } from '@mui/material';



const AdSpaceTokenPlansAdminPage: React.FC = () => {
  const [tab, setTab] = useState(0);

  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Tabs value={tab} onChange={handleTabChange} aria-label="AdSpaces admin tabs">
        <Tab label="List Token Plans" />
        <Tab label="Insert Token Plan" />
      </Tabs>
      <Box sx={{ mt: 2 }}>
        {tab === 0 && <AdSpaceTokenPlansAdminList />}
        {tab === 1 && <AdSpaceTokenPlansAdminAddTokenPlanPage />}
      </Box>
    </Box>
  );
};

export default AdSpaceTokenPlansAdminPage;